import { createSelector } from 'reselect';
import { find, map } from 'lodash';

const kitchensSelector = (state) => state.settings.kitchens;
const kitchenCodeSelector = (state) => state.order.data?.kitchen_code;

export const callCenterStopListSelector = createSelector(
  [kitchensSelector, kitchenCodeSelector],
  (kitchens, code) => {
    const kitchen = find(kitchens, { code });
    return map(kitchen?.stop_list ?? [], 'value');
  }
);
